import Toastify from 'toastify-js';

class Toast {
  constructor(options = {}) {
    this.config = {
      duration: 3000,
      close: true,
      ...options
    };

    this.typeMap = {
      success: {
        avatar: '/dist/images/icons/toast-success.png'
      },
      error: {
        avatar: '/dist/images/icons/toast-error.png'
      },
      warning: {
        avatar: '/dist/images/icons/toast-warning.png'
      }
    };
  }

  init() {
    const { config, typeMap } = this;

    const toast = ({ detail: { type, text } }) => {
      if (!['success', 'error', 'warning'].some(eventType => eventType === type)) {
        return;
      }

      Toastify({
        ...config,
        ...typeMap[type],
        text,
        className: `c-toast c-toast--${type}`
      }).showToast();
    };

    // Set global variable so we can check if Toastify is installed in project
    // Used for checkout, so we can use 'toastr' as fallback for older projects
    window.hasToastify = true;

    window.addEventListener('toast', toast);
  }
}

export default Toast;
